import { useFormik, Form, FormikProvider } from 'formik';
import { Button, Input, Select } from 'styled';
import InputField from 'components/formik/InputField';
import Model from 'components/Modal';
import { createDocument, getAllData, getById, updateDocumentByID } from 'apis/customApiHandler';
import { useQuery, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import axios from 'apis/axios';
import { useCallback, useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { TD, TH } from 'styled/table';
import getFormattedDate from 'utils/helpers';
import { useLocation } from 'react-router-dom';
import { saveErrorCreationEvent } from 'utils/analytics';
import { ANALYTICS_EVENTS } from 'utils/analyticsEvents';

const  Add = ({ data, handleClick, desable, getData }) => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"))

  const isEdit = !!data;

  function dtpEventFunc(eventName, modalName) {
    return saveErrorCreationEvent(eventName, modalName, "DTP Planning", location.pathname);
  }
  const [file, setFile] = useState(null);
  const [currentUser, setCurrentUser] = useState(null)
  // const [allHubs, setAllHubs] = useState()
  
  const getUser = async()=>{
    const response = await getById("/user/one", user._id);
    setCurrentUser(response?.data)
    // setAllHubs(data?.data?.hubs)
    if(!data?.hubs?.length) formik.setFieldValue("hubs", response?.data?.hubs)
  }
  useEffect(()=>{
     getUser();
  }, [])

  const formik = useFormik({
    initialValues: data ? data : {
      currentDate: getFormattedDate(new Date),
      hubs: currentUser?.hubs,
      quarter: getCurrentFinancialQuarter()
    },
    onSubmit: async (values) => {
      console.log('values--',values);
      try {
        dtpEventFunc(
          isEdit ? ANALYTICS_EVENTS.CLICK_EDIT_CHANGES : ANALYTICS_EVENTS.CLICK_SAVE_CHANGES,
          isEdit ? "Edit DTP Plan" : "Add DTP Plan"
        );
        const response = data ? await updateDocumentByID("dtp-planning", data._id, {...values,
          ...data.status === "Approved" && {action: "edit_after_approval"}
        }) : await createDocument('dtp-planning', {
          status: "Created",
          ...values,
        });
        if (response) {
          toast.success('Successfully saved');
          dtpEventFunc(
            isEdit ? ANALYTICS_EVENTS.SYS_EDIT_DTP_PLANNING_SUCCESS : ANALYTICS_EVENTS.SYS_ADD_DTP_PLANNING_SUCCESS,
            isEdit ? "Edit DTP Plan" : "Add DTP Plan"
          );
          queryClient.invalidateQueries('users');
          handleClick();
        }
      } catch (error) {
        dtpEventFunc(
          isEdit ? ANALYTICS_EVENTS.SYS_EDIT_DTP_PLANNING_ERROR : ANALYTICS_EVENTS.SYS_ADD_DTP_PLANNING_ERROR,
          isEdit ? "Edit DTP Plan" : "Add DTP Plan"
        );
        handleClick();
      } finally {
        getData();
      }
    },

    validate: (values) => {
      let errors = {};
      if(values.date && !values.quarter){
        errors.quarter = 'please select quarter first';
      }
      if (!values.quarter) errors.quarter = 'Required';
      console.log(values.hubs)
      if(values.hubs){
        values.hubs.map((item,index)=>{
          const year = new Date(item.date).getFullYear()
          const financialQuarterDate = getFinancialQuarterDates(year, values.quarter);
          const month = item.date ? new Date(item.date).getMonth() + 1 : new Date().getMonth() + 1
          if(month < new Date(financialQuarterDate.start).getMonth()+1 || month > new Date(financialQuarterDate.end).getMonth()+1  ){
            if(!errors.hubs || !Object.keys(errors.hubs)?.length){
              errors.hubs = {}
            }
            errors.hubs[index]= {date: "Date should lies in same Quarter"}
          }else if(new Date(item.date).getTime() < new Date().getTime()){
            if(!errors.hubs || !Object.keys(errors.hubs)?.length){
              errors.hubs = {}
            }
            errors.hubs[index]= {date: "Please select a date in Future"}
          }
        })
      }
      return errors;
    },
  });

  
  function getCurrentFinancialQuarter() {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // Adding 1 because months are zero-based
  
    if (month >= 1 && month <= 3) {
      return 4;
    } else if (month >= 4 && month <= 6) {
      return 1;
    } else if (month >= 7 && month <= 9) {
      return 2;
    } else {
      return 3;
    }
  }

  function getFinancialQuarterDates(year, quarter) {
    if(!quarter || !year){
      return {start:new Date(), end: new Date()}
    }
    const currentMonth = new Date().getMonth() +1 
    const quarters = {
      4: currentMonth<=3 ? { start: new Date(year, 0, 1), end: new Date(year, 2, 31) } : { start: new Date(year+1, 0, 1), end: new Date(year+1, 2, 31) },
      1: currentMonth<6 ? { start: new Date(year, 3, 1), end: new Date(year, 5, 30) } : { start: new Date(year+1, 3, 1), end: new Date(year+1, 5, 30) },
      2: currentMonth<9 ? { start: new Date(year, 6, 1), end: new Date(year, 8, 30) } : { start: new Date(year+1, 6, 1), end: new Date(year+1, 8, 30) },
      3: currentMonth<12 ? { start: new Date(year, 9, 1), end: new Date(year, 11, 31) } : { start: new Date(year+1, 9, 1), end: new Date(year+1, 11, 31) }
    };
  
    return quarters[quarter];
  }
  
  return (
    <Model handleClick={handleClick} title={'Add DTP Plan'} className="max-w-3xl">
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          <label className='flex flex-col justify-center items-start gap-0 text-gray-600 font-normal'>
            Current Date{" "}
            <InputField
              type="date"
              min={getFormattedDate()}
              name="currentDate"
              value={formik.values.currentDate}
              desable= {true}
            />
          </label>          
          <div className=" flex flex-col justify-center items-start gap-0 text-gray-600 font-normal">
            <label>Quarter</label>
            <Select
              name="quarter"
              value={formik.values.quarter}
              onChange={(e)=>{
                formik.setFieldValue("quarter", e.target.value)
                formik.setFieldValue("date", null)
              }}
            >
              {[1,2,3,4].map((role) => (
                <option key={role} value={role} 
                disabled={desable}
                // disabled={role < getCurrentFinancialQuarter()}
                >
                  {role}
                </option>
              ))}
            </Select>
            {formik.touched.userRole && formik.errors.userRole && (
              <p className="text-red-500 font-normal">
                {formik.errors.userRole}
              </p>
            )}
          </div>
           
            <div className= "flex col-span-2">
            <table className='w-full'>
             <TH>S.N.</TH>
             <TH>Fleet Name</TH>
             <TH>Hub Name</TH>
             <TH>Date</TH>
          {
            formik.values.hubs?.map((hub, index)=>{
             return (
               <tr
                 key={hub.hubId}
                 className={`${index % 2 !== 0 && "bg-gray-100"}`}
               >
                 <TD>{index + 1}</TD>
                 <TD>{hub.fleetName}</TD>
                 <TD>{hub.hubName}</TD>
                 <label className="flex flex-col justify-center items-start gap-0 text-gray-600 font-normal">
                   <InputField
                     type="date"
                     min={getFormattedDate(
                       getFinancialQuarterDates(
                         new Date().getFullYear(),
                         formik.values.quarter
                       ).start
                     )}
                     max={getFormattedDate(
                       getFinancialQuarterDates(
                         new Date().getFullYear(),
                         formik.values.quarter
                       ).end
                     )}
                     name={`hubs[${index}].date`}
                     desable={desable || !formik.values.quarter}
                    value={formik.values.hubs[index]?.date || ""}
                    onChange={(e) => {
                      formik.setFieldValue(`hubs[${index}].date`, e.target.value);
                    }}

                   />
                   {formik.errors.hubs?.length &&
                     formik.touched &&
                     formik.touched[`hubs[${index}]`] &&
                     formik.errors.hubs[index]?.date && (
                       <span className="text-red-400">
                         {" "}
                         {formik.errors.hubs[index].date}
                       </span>
                     )}
                 </label>
               </tr>
             );
            })
          }
          </table>
          </div>
        </Form>
        <div className="px-5 flex justify-end items-center gap-4 py-8 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            Cancel
          </Button>
          <Button type="button" bgPrimary onClick={formik.handleSubmit} disabled={desable ||  Object.keys(formik.errors)?.length}>
            Save Changes
          </Button>
        </div>
      </FormikProvider>
    </Model>
  );
};

export default Add;

